/* Rquiere de mixin.js */

var inventories = {
	data() {
		return {
			listInventories: [],
			loadingInventories: false,
			methodsInventory: {
				get: 'inventories',
				show: 'inventory/',
				create: 'inventory/register',
			},
			paginationInventories: [],
			searchInventories: '',
			objectInventory: {
				exist: 0,
				id: 0,
				description: '',
				year: 0,
				inventory_date: ''
			},
			qRowsInventory: 25
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		changeQRowsInventory() {
			localStorage.setItem('qRowsInventory', this.qRowsInventory)
			this.getAllInventories()
		},
		clearObjectInventory() {
			this.objectInventory.exist = 0
			this.objectInventory.id = 0
			this.objectInventory.description = ''
			this.objectInventory.year = 0
			this.objectInventory.inventory_date = ''
		},
		downloadInventory(id) {
			let url = this.getApiBackend + 'inventory/' + id + '/exportResume'
			window.location.href = url
		},
		getInventoryResume(id, page = 1, search = '') {
			this.loadingInventories = true
			let param = '?page=' + page + '&search=' + search
			let url = this.getApiBackend + 'inventory/' + id + '/templateResume' + param
			this.axiosActionIS(url, 'GET', 'getInventoryResumeResult')
		},
		getInventoryResumeResult(response) {
			this.loadingInventories = false
			this.getInventoryResumeResultLocal(response)
		},
		getInventoryResumeResultLocal(response) {
			console.log('getInventoryResumeResultLocal no desarrollado', response)
		},
		getAllInventories(page = 1, all = 0) {
			this.loadingInventories = true
			this.listInventories = []
			this.paginationInventories = []
			let parameters = '?search=' + this.searchInventories + '&page=' + page
			parameters = (all == 0) ? parameters + '&qRow=' + this.qRowsInventory : parameters
			let url = this.getApiBackend + this.methodsInventory.get + parameters
			this.axiosActionIS(url, 'GET', 'getAllInventoriesResult')
		},
		getAllInventoriesResult(response) {
			this.loadingInventories = false
			if (response.data.success == true) {
				this.listInventories = response.data.data
				this.paginationInventories = response.data.paginate
			}
			this.getAllInventoriesResultLocal(response)
		},
		getAllInventoriesResultLocal(response) {
			console.log('getAllInventoriesResultLocal no desarrollado', response)
		},
		setObjectInventory(item) {
			for (const property in item) {
				this.objectInventory[property] = item[property]
			}
		},
		saveInventory() {
			let url = this.getApiBackend + this.methodsInventory.create
			this.axiosActionIS(url, 'POST', 'saveInventoryResult', this.objectInventory)
		},
		saveInventoryResult(response) {
			if (response.data.success == true) {
				this.listInventories.unshift(response.data.data)
			}
			this.saveInventoryResultLocal(response)
		},
		saveInventoryResultLocal(response) {
			console.log('saveInventoryResultLocal no desarrollado', response)
		},
		showInventory(id) {
			this.loadingInventories = true
			let url = this.getApiBackend + 'inventory/' + id
			this.axiosActionIS(url, 'GET', 'showInventoryResult')
		},
		showInventoryCurrent() {
			this.loadingInventories = true
			let url = this.getApiBackend + 'inventory/current'
			console.log(url)
			this.axiosActionIS(url, 'GET', 'showInventoryResult')
		},
		showInventoryResult(response) {
			this.loadingInventories = false
			if (response.data.success == true) {
				this.setObjectInventory(response.data.data)
			}
			this.showInventoryResultLocal(response)
		},
		showInventoryResultLocal(response) {
			console.log('showInventoryResultLocal no desarrollado', response)
		}

	},
};

export default inventories;